import { HandLookup } from '@/api/models';

export interface IHandOptionMap {
  map: Record<string, HandLookup>;
  options: Array<{
    id: string;
    label: string;
  }>;
}

export const buildHandDropdown = (handLookup: HandLookup[]) => {
  const map: Record<string, HandLookup> = {};
  const options: { id: string; label: string }[] = [];

  handLookup.forEach((hand) => {
    const label = hand.name === 'RH' ? 'Right' : 'Left';
    map[label] = hand;
    options.push({ id: label, label: label });
  });

  return { map, options };
};

export const handFullNameToAbbreviation = (hand: string) => {
  let newHand = '';
  switch (hand.toLowerCase()) {
    case 'right':
      newHand = 'RH';
      break;
    case 'left':
      newHand = 'LH';
      break;
  }
  return newHand;
};

export const handAbbreviationToFullName = (hand: string) => {
  let newHand = '';
  switch (hand.toLowerCase()) {
    case 'rh':
      newHand = 'Right';
      break;
    case 'lh':
      newHand = 'Left';
      break;
  }
  return newHand;
};
